// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ux","category":"uy","tab":"uz","selected":"uA","isRental":"uB"};